import React from "react";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { Box } from "@chakra-ui/react";
import geoData from "./geo.json";
import AchievementsBox from "./StatsCounter";

// Custom label offsets for countries where text overlaps
const CITIES = [
  { name: "India", coordinates: [78.9629, 20.5937] },
  { name: "United States", coordinates: [-95.7129, 37.0902] },
  { name: "Canada", coordinates: [-106.3468, 56.1304] },
  {
    name: "Thailand",
    coordinates: [100.9925, 15.87],
    labelOffset: { x: 25, y: 0 },
  },
  { name: "South Korea", coordinates: [127.7669, 35.9078] },
  { name: "Germany", coordinates: [10.4515, 51.1657] },
  { name: "China", coordinates: [104.1954, 35.8617] },
  { name: "Malaysia", coordinates: [101.9758, 4.2105] },
  {
    name: "Vietnam",
    coordinates: [108.2772, 14.0583],
    labelOffset: { x: -30, y: 12 },
  },
  {
    name: "Philippines",
    coordinates: [121.774, 12.8797],
    labelOffset: { x: 28, y: -10 },
  },
];

export default function WorldMap() {
  return (
    <Box
      w="100vw"
      maxW="100vw"
      mx="auto"
      my={{ base: 8, md: 16 }}
      px={{ base: 2, md: 6 }}
      bg="#F7FBFA" // soft, very light green-blue background (different from white)
      borderRadius="xl"
      boxShadow="0 0 15px rgba(81, 156, 54, 0.2)" // subtle green glow around container
      p={4}
    >
      <AchievementsBox />
      <ComposableMap
        projectionConfig={{
          scale: 230,
          center: [20, 20],
        }}
        width={1200}
        height={700}
        style={{
          width: "100%",
          height: "auto",
        }}
      >
        <Geographies geography={geoData}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#DFF4E1" // very light green fill for countries
                stroke="#A0C97D" // soft green borders
                strokeWidth={0.8}
              />
            ))
          }
        </Geographies>

        {CITIES.map(({ name, coordinates, labelOffset }) => (
          <Marker key={name} coordinates={coordinates}>
            <circle
              r={9}
              fill="#38A169" // medium green fill for glow
              stroke="#FFFFFF"
              strokeWidth={3}
              filter="drop-shadow(0 0 6px #38A169)" // green glowing effect
            />
            <circle r={7} fill="#519C36" stroke="#FFFFFF" strokeWidth={2.5} />
            <text
              textAnchor="middle"
              x={labelOffset?.x || 0}
              y={-12 + (labelOffset?.y || 0)}
              style={{
                fontFamily: "system-ui",
                fill: "#2F4F2F",
                fontSize: "13px",
                fontWeight: "bold",
                paintOrder: "stroke",
                stroke: "#FFFFFF",
                strokeWidth: 2,
                strokeLinejoin: "round",
                userSelect: "none",
              }}
            >
              {name}
            </text>
          </Marker>
        ))}
      </ComposableMap>
    </Box>
  );
}
